module.exports = __webpack_public_path__ + "img/ic_all_quote_price.f91880e5.svg";